module.exports = __webpack_public_path__ + "/build/web/images/recently-posted.108bc959995e24f68b83462a870abf86.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/recently-posted.jpg
// module id = 188
// module chunks = 13